import { useEffect } from "react";

import { useRouter } from "@lib/router";

import { OrderFields } from "../../constants";
import getIsDeliveryFromOriginCountry from "../../utils/getIsDeliveryFromOriginCountry";
import useOrderFormik from "../useOrderFormik";

const useUpdateIsFromOriginCountry = (): void => {
  const {
    values: { [OrderFields.STARTING_COUNTRY]: countryFrom },
    setFieldValue,
  } = useOrderFormik();

  const { defaultLocale } = useRouter();

  useEffect(() => {
    const isFromOrigin = getIsDeliveryFromOriginCountry(defaultLocale!, countryFrom!);
    setFieldValue(OrderFields.IS_FROM_ORIGIN, isFromOrigin);
  }, [countryFrom, defaultLocale, setFieldValue]);
};
export default useUpdateIsFromOriginCountry;
